import React, { Component, memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Slider from '../Slider'
import TopicLayout from '../TopicLayout/TopicLayout'
import Topic from '../Topic/Topic'

const Container = styled.div`
  ${({ xPos, yPos, width, minWidth, height }) => ({
    position: 'absolute',
    transform: `translate(${xPos}px, ${yPos}px)`,
    width,
    minWidth,
    height,
  })};

  > * {
    width: 100%;
  }
  padding: 0 0.5rem;
`

/**
 * Timeline that composes slider and layout component
 */
class Timeline extends Component {
  static propTypes = {
    topics: PropTypes.array,
    min: PropTypes.number,
    max: PropTypes.number,
    current: PropTypes.number,
    width: PropTypes.number,
    selectedID: PropTypes.number,
    /** Function as a child, arguments: min, max, width */
    renderSlider: PropTypes.func,
    onYearChange: PropTypes.func,
    onTopicChange: PropTypes.func,
  }

  render() {
    const {
      min,
      max,
      current,
      width,
      topics,
      renderSlider,
      onYearChange,
      onTopicChange,
      selectedID,
    } = this.props
    const size = { min, max, width }
    return (
      <>
        <TopicLayout topics={topics} {...size}>
          {data =>
            data.map(
              ({ data: { id, start, end, type }, widthAbs, ...layout }) => {
                // Shorten label if element is to small
                const text =
                  widthAbs > 200
                    ? `${start} – ${end}`
                    : widthAbs > 140
                    ? start.toString()
                    : ''
                return (
                  <Container {...layout} key={`topic-${id}`}>
                    <Topic
                      id={id}
                      icon={type}
                      text={text}
                      inverse={id !== selectedID}
                      onClick={onTopicChange}
                    />
                  </Container>
                )
              }
            )
          }
        </TopicLayout>
        {renderSlider ? (
          renderSlider(size)
        ) : (
          <Slider
            {...size}
            stepSize={10}
            highlightStep={50}
            onChange={onYearChange}
            current={current}
          />
        )}
      </>
    )
  }
}

export default memo(Timeline)
